import { listingTranslate } from '@/i18n/translations/listingTranslations';

export const ProductListLengthInfo = ({ totalItems }: { totalItems: number }) => {
  return (
    <p className="hidden lg:block text-xs self-end text-(--mui-palette-text-disabled)">
      {listingTranslate('product-count')}: {totalItems}
    </p>
  );
};
